import React from "react";
import { AxiosResponse } from "axios";
import DataGrid, { Paging, Column, Editing, Scrolling } from "devextreme-react/data-grid";
import { LoadPanel } from "devextreme-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import notify from "devextreme/ui/notify";
import GlobalService from "../../services/GlobalService";
import { SelectBox, Popup, ScrollView, RadioGroup } from "devextreme-react";
import LookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import { RadioButtonOnSelectionChanged, SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import FindAnArtistUtils from "../../../src/components/FindAnArtist/FindAnArtistUtils";
import PendingRequestService, { statusTypes, updateRequest } from "../../services/PendingRequestService";
import FileService from "../../../src/services/FileService";
//props
interface BulkGigCancelProps {}
// State

export interface BulkGigRowItem {
    id: string;
    requestStatus: string;
    error: string;
    result: string;
}
interface BulkGigCancelState {
    pastedGridDataSource: BulkGigRowItem[];
    matchingGridDataSource: any[];
    findMatchesClicked: boolean;
    showFindMatches: boolean;
    showSendInvites: boolean;
    showMatchingGrid: boolean;
    showLoadPanel: boolean;
    selectedMatchingData: any[];
    reloadMatchingGrid: boolean;
    userResponseData: any[];
    errorMsg: any[];
    isCancelRequestPopupvisible: boolean;
    cancellationReasonLookUp: LookupTypeItem[];
    cancellationreasonId: string;
    isShowReplacementReason: boolean;
    rePublishGigRequest: string;
    errorMessage: [];
    gigType: string;
}
class BulkGigCancel extends React.Component<BulkGigCancelProps> {
    //Initialize the component's state.
    state: BulkGigCancelState;
    dataGridRef: any;
    lookUpService: LookupService;
    utils: FindAnArtistUtils;
    replacementArtistList: LookupTypeItem[];
    pendingRequestService: PendingRequestService;
    fileService: FileService;
    constructor(props: BulkGigCancelProps) {
        super(props);
        // Initialize state and services/utils
        this.dataGridRef = null;
        this.lookUpService = new LookupService();
        this.utils = new FindAnArtistUtils();
        this.fileService = new FileService();
        this.pendingRequestService = new PendingRequestService();
        this.replacementArtistList = this.lookUpService.getReplacementArtist();
        this.state = {
            pastedGridDataSource: [],
            showLoadPanel: false,
            showFindMatches: false,
            showMatchingGrid: false,
            showSendInvites: false,
            matchingGridDataSource: [],
            findMatchesClicked: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            userResponseData: [],
            errorMsg: [],
            isCancelRequestPopupvisible: false,
            cancellationReasonLookUp: [],
            cancellationreasonId: "",
            isShowReplacementReason: false,
            rePublishGigRequest: "",
            errorMessage: [],
            gigType: "",
        };
    }

    componentDidMount() {
        let obj = this.getDefaultObject(0);
        let stateArr = this.state.pastedGridDataSource;
        stateArr.push(obj);
        this.setState({ pastedGridDataSource: stateArr });
        this.lookUpService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.cancellationReason)
            .then(this.handleCancellationLookUpSuccess)
            .catch(this.handleError);
        let gigType = GlobalService.getGigComingFrom();
        this.setState({ gigType: gigType });
    }
    handleSuccessServiceTypeLookupSuccess = (response: AxiosResponse<any>) => {
        if (response && response.data.data) {
            this.setState({
                venueType: response.data.data,
            });
        }
    };
    handleError = (err: any) => {
        this.setState({
            errorMessage: err.response ? JSON.parse(JSON.stringify(err.response?.data?.error)) : null, // For capturing response at the time of exception and showing error message
        });
    };
    //When a component is updated this lifecycle method is called, and a change in props here would trigger this.
    componentDidUpdate(prevProps: BulkGigCancelProps, prevState: BulkGigCancelState) {
        if (this.state.gigType !== GlobalService.getGigComingFrom()) {
            this.onRefreshClick();
            this.setState({ gigType: GlobalService.getGigComingFrom() });
        }
    }

    isSendInvitesDisabled = () => {
        let disabled = true;
        let inviteUsers = this.state.selectedMatchingData.filter((a) => a.canInviteUser);
        if (this.state.matchingGridDataSource?.length > 0 && inviteUsers?.length > 0) {
            disabled = false;
        }
        return disabled;
    };
    handleCancellationLookUpSuccess = (response: AxiosResponse<any>) => {
        if (response && response.data && response.data.data && response.data.data && response.data.data.length > 0) {
            let cancellationDropDown = this.utils
                .lookUpCreation(response)
                .map((item) =>
                    item.value === "Other - enable text field"
                        ? { ...item, value: "Other" }
                        : item
                );
            this.setState({
                cancellationReasonLookUp: cancellationDropDown,
            });
        }
    };
    isMissingUsersDisabled = () => {
        let disabled = true;
        let missingUser = this.state.selectedMatchingData.filter((a) => a.canCRUDUser);
        if (missingUser && missingUser?.length > 0) {
            disabled = false;
        }
        return disabled;
    };

    isCreateUserDisabled = () => {
        let disabled = true;
        let inviteUsers = this.state.selectedMatchingData.filter(
            (a) => a.found === "Venue Not Found" || a.found === "Duplicate Venue"
        );
        if (inviteUsers?.length > 0 || this.state.selectedMatchingData.length == 0) {
            disabled = true;
        } else {
            disabled = false;
        }
        return disabled;
    };

    getDefaultObject = (index: any) => {
        let obj: BulkGigRowItem = {
            id: "click here to paste from excel",
            requestStatus: "",
            error: "",
            result: "",
        };
        return obj;
    };

    checkForRowsToAdd = (currentRowIndex: any, pastedRows: any) => {
        let patedsRowLength = pastedRows.length;
        let gridRows = this.state.pastedGridDataSource;
        let availableRows = gridRows.slice(currentRowIndex, gridRows.length);
        if (availableRows?.length <= patedsRowLength) {
            let rowsToadd = patedsRowLength - availableRows.length;
            for (let i = 0; i < rowsToadd; i++) {
                let index = gridRows.length;
                let obj = this.getDefaultObject(index);
                gridRows.push(obj);
            }
        }
        return gridRows;
    };

    handlePaste = (editEvent: any, e: any, currentRow: any, currentDataField: any) => {
        let pastedData = e.clipboardData.getData("Text");
        let pastedRows = pastedData.split("\n")?.filter((a: any) => a !== "");
        let rowIndex = currentRow.dataIndex;
        let stateObj = this.checkForRowsToAdd(rowIndex, pastedRows);
        let allRows = stateObj;
        pastedRows.forEach((element: any, rindex: any) => {
            let roToUpdate = rowIndex + rindex;
            let currPastedRow = pastedRows[rindex];
            let splittedCells = currPastedRow.replace(/(\r)/gm, "").split("\t");
            let currRow = allRows[roToUpdate];
            const dataFields = Object.keys(currRow);
            //check for duplicate
            for (let fieldID = 0; fieldID < dataFields.length; fieldID++) {
                if (dataFields[fieldID] === currentDataField) {
                    for (let i = 0; i < dataFields.length - fieldID && i < splittedCells.length; i++) {
                        let key = dataFields[fieldID + i];
                        let val = splittedCells[i];
                        this.dataGridRef?.instance()?.cellValue(roToUpdate, key, val);
                        if (key == "id") {
                            currRow.id = val;
                        } else if (key == "requestStatus") {
                            currRow.requestStatus = val;
                        } else if (key == "result") {
                            currRow.result = val;
                        }
                        if (currRow.id == "click here to paste from excel") {
                            currRow.id = "";
                        }
                        currRow.error = "";
                        //}
                    }
                }
            }
        });
        this.dataGridRef?.instance()?.saveEditData();
        this.setState({ pastedGridDataSource: stateObj, showFindMatches: true });
        editEvent.cancel = true;
    };

    onCellClick = (clickEvent: any) => {
        const currentDataField = clickEvent.column.dataField;
        const currentRow = clickEvent.row;

        clickEvent.cellElement.onpaste = (pasteEvent: any) => {
            this.handlePaste(clickEvent, pasteEvent, currentRow, currentDataField);
        };
    };

    onRefreshClick = () => {
        let obj = this.getDefaultObject(0);
        let stateArr = [];
        stateArr.push(obj);

        this.setState({
            pastedGridDataSource: stateArr,
            showFindMatches: false,
            findMatchesClicked: false,
            showSendInvites: false,
            matchingGridDataSource: [],
            showMatchingGrid: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            userResponseData: [],
            errorMsg: "",
        });
    };

    updateFoundRecords = () => {
        this.setState({
            showSendInvites: true,
            findMatchesClicked: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            showLoadPanel: false,
        });
    };

    setSelectedRows = (rows: any) => {
        this.setState({ selectedMatchingData: rows });
    };

    handleSuccess = (response: AxiosResponse<any>, flow: string, requestArr: any) => {
        this.setState({
            showLoadPanel: false,
        });
        if (flow) {
            notify({ message: "Operations Completed!", width: 300, shading: true, position: "center" }, "success", 600);
        }
    };

    handleFailure = (error: any) => {
        if (error.response.status === 400) {
            let newdata: any = this.state.selectedMatchingData.map((parentItem, index) => {
                return {
                    ...parentItem,
                    validationErrors: error.response.data.data[index].validationErrors,
                };
            });
            let updatedPastedGridDataSource: any = this.state.pastedGridDataSource.map((parentItem: any) => {
                const matchingChild = newdata.find(
                    (childItem: any) =>
                        childItem.businessEntityId === parentItem.businessEntityId &&
                        childItem.venueName === parentItem.venueName &&
                        childItem.id === parentItem.id &&
                        childItem.businessEntity?.shortName === parentItem.businessEntity &&
                        childItem.houseNumber === parentItem.houseNumber &&
                        childItem.venueName === parentItem.venueName &&
                        childItem.address === parentItem.address &&
                        childItem.city === parentItem.city &&
                        childItem.county === parentItem.county &&
                        childItem.postCode === parentItem.postCode &&
                        childItem.phone === parentItem.phone &&
                        childItem.email === parentItem.email &&
                        childItem.brand === parentItem.brand &&
                        childItem.division === parentItem.division &&
                        childItem.website === parentItem.website &&
                        childItem.venueNameWOLocation === parentItem.venueNameWOLocation &&
                        childItem.venueType.value === parentItem.venueTypeId
                );
                return {
                    ...parentItem,
                    errorMessage: matchingChild?.validationErrors ?? parentItem.errorMessage ?? [],
                };
            });
            this.setState(
                {
                    showLoadPanel: false,
                    pastedGridDataSource: updatedPastedGridDataSource,
                },
                () => {
                    notify(
                        { message: "Sorry! The operation could not be completed.", width: 300, shading: true },
                        "error",
                        600
                    );
                }
            );
        } else {
            this.setState(
                {
                    showLoadPanel: false,
                },
                () => {
                    notify(
                        { message: "Sorry! The operation could not be completed.", width: 300, shading: true },
                        "error",
                        600
                    );
                }
            );
        }
    };

    onDownloadClick = () => {
        let downloadId = "bulkcancelgigrequests";
        if (downloadId) {
            this.setState({
                showLoadPanel: true,
            });
            this.fileService
                .downloadTemplate(downloadId)
                .then(this.handleDownloadSuccess)
                .catch(this.handleDownloadError);
        }
    };

    handleDownloadSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            showLoadPanel: false,
        });
        saveAs(response.data, "template_bulk_cancel_request.xlsx");
    };

    handleDownloadError = (error: any) => {
        this.setState({
            showLoadPanel: false,
        });
    };
    onClickCancelRequest = () => {
        this.setState({ cancellationreasonId: "", rePublishGigRequest: "" }, () => {
            let gigType = GlobalService.getGigComingFrom();
            if (gigType !== "Entertainment") {
                this.onCancelRequestConfirmation();
            } else {
                this.showCancelRequestPopup();
            }
        });
    };

    onCancelRequestConfirmation = () => {
        this.hideCancelRequestPopup();
        this.setState({ showLoadPanel: true });
        let isRePublish: boolean | null = null;
        if (this.state.rePublishGigRequest == "true") {
            isRePublish = true;
        } else if (this.state.rePublishGigRequest == "false") {
            isRePublish = false;
        }

        let updatedRequestObject: updateRequest = {
            requestStatusValue: statusTypes.Cancelled,
            cancellationreasonId: this.state.cancellationreasonId,
            rePublishGigRequest: isRePublish,
        };
        this.pendingRequestService
            .bulkCancelGigRequest({
                requestCancelIdList: this.state.pastedGridDataSource,
                requestCancelObjDetails: updatedRequestObject,
            })
            .then(this.handleCancelRequestSuccess)
            .catch(this.handleFailure);
    };
    handleCancelRequestSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            showLoadPanel: false,
            pastedGridDataSource: response.data.data,
        });
    };

    showCancelRequestPopup = () => {
        this.setState({
            isCancelRequestPopupvisible: true,
        });
    };
    hideCancelRequestPopup = () => {
        this.setState({
            isCancelRequestPopupvisible: false,
        });
    };
    handleChangeCancellationRequest = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({ cancellationreasonId: dxValueChange.value }, () => {
            this.showReplacementReason(dxValueChange.value);
        });
    };
    handleChangerReplacementReason = (dxValueChange: RadioButtonOnSelectionChanged) => {
        this.setState({
            rePublishGigRequest: dxValueChange.value,
        });
    };
    showReplacementReason = (cancelReasonId: string) => {
        if (cancelReasonId == "30") {
            this.setState({
                isShowReplacementReason: true,
            });
        } else {
            this.setState({
                isShowReplacementReason: false,
            });
        }
    };
    render() {
        let header = "Manage Bulk Items";
        return (
            <>
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.showLoadPanel} />
                <div style={{ display: "flex" }}>
                    <h2 className="page-title__black-table">
                        {header}
                        <button
                            className="status-flow__refresh-button btn icon-btn"
                            aria-label="Refresh the current manage pay dates"
                            onClick={this.onRefreshClick}
                        >
                            <FontAwesomeIcon icon={faSync} title="reset grid data" />
                        </button>
                    </h2>
                    <h5 style={{ padding: "15px 0px 0px 15px" }}>
                        <Link
                            onClick={(e) => {
                                this.onDownloadClick();
                            }}
                            className="approval-query-column"
                            to="#"
                        >
                            Download Template
                        </Link>
                    </h5>
                </div>
                <DataGrid
                    dataSource={this.state.pastedGridDataSource}
                    showBorders={false}
                    showColumnLines={false}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    columnResizingMode={"widget"}
                    noDataText={"No data found for the filters applied"}
                    onCellClick={this.onCellClick}
                    ref={(ref) => {
                        this.dataGridRef = ref;
                    }}
                >
                    <Paging defaultPageSize={20} enabled={true} />
                    <Scrolling mode="infinite" />
                    <Editing mode="cell" allowUpdating={false} startEditAction="click" allowDeleting={false} />
                    <Column dataField="id" caption="ID" />
                    <Column dataField="requestStatus" caption="STATUS" />
                    <Column dataField="error" caption="VALIDATION MESSEGES" />
                    <Column dataField="result" caption="RESULT" />
                </DataGrid>
                <div className="col-12 col-lg-2 mb-3 mr-auto">
                    <button
                        className="btn btn-primary btn--large mt-3"
                        type="button"
                        disabled={!this.state.showFindMatches}
                        onClick={(e: React.MouseEvent) => {
                            //e.preventDefault();
                            this.onClickCancelRequest();
                        }}
                    >
                        BULK CANCEL
                    </button>
                </div>
                <Popup
                    visible={this.state.isCancelRequestPopupvisible}
                    onHiding={this.hideCancelRequestPopup}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title={"CANCELLATION REASON"}
                    resizeEnabled={true}
                    width="550px"
                    height="auto"
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="card">
                                <div className="card-body">
                                    <p>Please Select a reason for cancellation</p>
                                    <br></br>
                                    <SelectBox
                                        dataSource={this.state.cancellationReasonLookUp}
                                        displayExpr={"value"}
                                        valueExpr={"id"}
                                        onValueChanged={this.handleChangeCancellationRequest}
                                        value={this.state.cancellationreasonId}
                                    />
                                    {this.state.isShowReplacementReason ? (
                                        <>
                                            <p className="mt-3">Does the venue require a replacement artist?</p>
                                            <RadioGroup
                                                items={
                                                    this.replacementArtistList && this.replacementArtistList.length > 0
                                                        ? this.replacementArtistList
                                                        : []
                                                }
                                                displayExpr="value"
                                                valueExpr="id"
                                                onValueChanged={this.handleChangerReplacementReason}
                                                layout="horizontal"
                                            />
                                        </>
                                    ) : null}
                                    <button
                                        className="btn btn-primary btn--large mt-3"
                                        onClick={(e: React.MouseEvent) => {
                                            e.preventDefault();
                                            this.onCancelRequestConfirmation();
                                        }}
                                    >
                                        SUBMIT CANCELLATION
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
            </>
        );
    }
}
export default BulkGigCancel;
